import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import images from "../../images";
import { toast } from "react-toastify";
import { FormFieldSigIn } from "../../components/common/Input/InputSignIn";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [email, setEmail] = useState("");

  const handleInputChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSend = async () => {
    if (!email) {
      toast.error(t("forgotPassword.pleaseEnterEmail"));
      return;
    }

    try {
      // const response = await forgotPassword({ email }).unwrap();

      // Simulating success for now
      toast.success(t("forgotPassword.passwordResetLinkSent"));

      navigate(`/verify-otp?email=${encodeURIComponent(email)}`);
    } catch (err) {
      toast.error(
        err?.data?.detail[0].msg || t("forgotPassword.failedToSendResetLink")
      );
      // console.error("Error:", err);
    }
  };

  return (
    <main className="mx-auto w-full bg-yellow-50 max-w-[480px] min-h-screen flex flex-col">
      <Helmet>
        <meta name="theme-color" content="#fefce8" />
      </Helmet>
      <section className="flex justify-center items-center w-full h-[300px]">
        <img src={images.LogoLogin} className="w-[180px]" alt="Logo" />
      </section>

      <section className="flex flex-col flex-grow px-4 py-6 w-full bg-white rounded-t-[20px] shadow-[0px_0px_4px_rgba(0,0,0,0.08)]">
        <div className="flex flex-col items-center justify-center w-full max-w-[340px] mx-auto">
          <section className="w-full text-center mb-6">
            <h1 className="text-4xl font-bold text-gray-800">
              {t("forgotPassword.title")}
            </h1>
            <div className="mt-3">
              <span className="inline-block px-3 py-1.5 text-xs text-amber-400 bg-yellow-50 rounded-xl">
                {t("forgotPassword.weWillSendEmail")}
              </span>
            </div>
          </section>

          <div className="flex flex-col w-full text-sm text-neutral-500">
            <FormFieldSigIn
              placeholder={t("signIn.email")}
              icon={images.LetterIcon}
              type="email"
              name="email"
              value={email}
              onChange={handleInputChange}
            />

            <button
              onClick={handleSend}
              className="w-full px-4 py-3 mt-5 text-lg font-semibold text-white bg-[#3F54DF] rounded-xl"
            >
              {t("base.continue")}
            </button>

            <div className="mt-5 w-full text-center">
              <span
                onClick={() => navigate("/sign-in")}
                className="text-indigo-600 font-bold cursor-pointer"
              >
                {t("forgotPassword.backToSignIn")}
              </span>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
